import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { CreditCard } from '../state/types'

export const useCreditCardLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllCreditCards = (active = false) => getList(TableName.CREDIT_CARDS, active) as CreditCard[]

        const findCreditCard = (id?: string) => find(TableName.CREDIT_CARDS, id) as O<CreditCard>

        const loadAllCreditCards = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.CREDIT_CARDS, options)
            return response.dataTypes as CreditCard[]
        }

        const loadCreditCard = (id: string, dbRequest = false) => {
            const { load } = loaders(companyId)
            return load(TableName.CREDIT_CARDS, id, dbRequest) as Promise<O<CreditCard>>
        }
        
        return {
            findAllCreditCards,
            findCreditCard,
            loadAllCreditCards,
            loadCreditCard
        }
    }
}
